const parts = ['container', 'control', 'label', 'icon']

function baseStyleControl(props: Record<string, any>) {
  const { colorScheme: c } = props

  return {
    w: '100%',
    transitionProperty: 'box-shadow',
    transitionDuration: 'normal',
    border: '1px solid',
    borderRadius: 'none',
    borderColor: 'ghost',
    color: 'white',

    _checked: {
      bg: c,
      borderColor: c,
      color: 'white',

      _disabled: {
        borderColor: 'quartz',
        bg: 'ghost',
        color: 'smoke',
      },
    },

    _indeterminate: {
      bg: c,
      borderColor: c,
      color: 'white',
    },

    _disabled: {
      bg: 'quartz',
      borderColor: 'manatee',
    },

    _invalid: {
      borderColor: 'error',
    },
  }
}

const baseStyleLabel = {
  userSelect: 'none',
  _disabled: { opacity: 0.4 },
}

const baseStyleIcon = {
  transitionProperty: 'transform',
  transitionDuration: 'normal',
}

const baseStyle = (props: Record<string, any>) => ({
  icon: baseStyleIcon,
  control: baseStyleControl(props),
  label: baseStyleLabel,
})

const sizes = {
  sm: {
    control: { h: 'size-1', w: 'size-1' },
    label: { fontSize: 'font-small' },
    icon: { fontSize: '0.45rem' },
  },
  md: {
    control: { w: 'size-4', h: 'size-4' },
    label: { fontSize: 'font-body' },
    icon: { fontSize: '0.625rem' },
  },
  lg: {
    control: { w: 'size-3', h: 'size-3' },
    label: { fontSize: 'font-large' },
    icon: { fontSize: '0.625rem' },
  },
}

const defaultProps = {
  size: 'md',
  colorScheme: 'licorice',
}

export const checkboxTheme = {
  parts,
  baseStyle,
  sizes,
  defaultProps,
}
